import { useQuery } from '@tanstack/react-query'
import { fetchReviewChartAggregations } from 'services/verticalsApi'
import type { ListingReviewQueryParams } from './reviewQueryUtils'
import { REVIEW_ACTIVITY_TYPE, buildListingFilters } from './reviewQueryUtils'

export const useListingReviewChartQuery = ({ entityId, listingId, activityIndex }: ListingReviewQueryParams) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['str-listing-review-chart', entityId, listingId, activityIndex],
    queryFn: () =>
      fetchReviewChartAggregations(entityId!, buildListingFilters(listingId!), activityIndex, REVIEW_ACTIVITY_TYPE),
    enabled: !!entityId && !!listingId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  })

  return {
    chartData: data?.chartBuckets ?? [],
    platformCounts: data?.platformCounts ?? {},
    total: data?.total ?? 0,
    isLoading,
    isError,
  }
}
